namespace Ir.Components.Workbook.Settings.Items.InfoDrilldownSetting {
    interface IViewModel {
        visible: KnockoutObservable<boolean>;
    }

    interface IParams {
        
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.visible = ko.computed(() => {
            return workbook?.workbookConfig?.activeTabOrWidget()?.drilldownManager?.isDrilldown && !workbook?.workbookConfig?.activeTabOrWidget()?.drilldownManager.isDifferentWidgetType;
        });
    }
}